import { Component, ElementRef, HostListener, OnInit, Input, ViewChild } from '@angular/core';

@Component({
    selector: '[blurred-image]',
    templateUrl: './blurred-image.component.html',
    styleUrls: ['./blurred-image.component.scss']
})

export class BlurredImageComponent {

  elem: any;
	preview: any = {};
  small: any = {};

	@Input('small')
    set smallPath(value: any) {
        if (value) {
            this.small.path = value;
        }
    }

	@Input('preview')
    set previewPath(value: any) {
        if (value) {
            this.preview.path = value;
        }
    }

	  constructor(private elementRef: ElementRef){
        this.elem = this.elementRef.nativeElement;
    }

    @HostListener("window:scroll", [])
    onWindowScroll() {
        if (this.checkElemPosition()){
        	this.show();
        }
    }

    ngOnInit(): void {
        if (this.checkElemPosition()){
            this.show();
        }
    }

    show(){
    	this.preview.ready = true;
      this.small.ready = true;
      this.small.loaded = true;
    }

    onLoaded(event: any){
      setTimeout(() => {
        this.preview.loaded = true;
      }, 10); //small timeout to allow other images to be loaded before this one
    }

    checkElemPosition(){
        return window.pageYOffset + window.innerHeight*2 >= this.elem.offsetTop;
    }
}
